import api from '@pray/shared/utils/api';

import type { RestoreSeedsResponse } from './types';

const RESTORE_URL = '/web/studio/admin/seed-emails/seeds/restore';

/**
 * Brings deleted seeds back. The server's window is 24 hours; the 10 seconds the notice counts down
 * are an affordance, not the deadline.
 */
export async function postRestoreSeeds(seedIds: string[]) {
  const res = await api.executePostRequest<{ data: RestoreSeedsResponse }>(RESTORE_URL, {
    seed_ids: seedIds,
  });
  return res.data.data;
}
